var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "cjt-progress-box" }, [
        _c("div", { staticClass: "table-content" }, [
          _c(
            "div",
            { staticClass: "order-heaer" },
            [
              _c("h3", [_vm._v("进度查询")]),
              _vm._v(" "),
              _c(
                "a-form",
                {
                  attrs: {
                    "label-col": { span: 4 },
                    "wrapper-col": { span: 16 }
                  }
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                allowClear: "",
                                "show-search": "",
                                "option-filter-prop": "children",
                                placeholder: "所有国家"
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm.countryList.length == 0
                                    ? {
                                        key: "dropdownRender",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "select-data" },
                                              [_vm._v("暂无数据")]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : null
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.speedForm.countryCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.speedForm, "countryCode", $$v)
                                },
                                expression: "speedForm.countryCode"
                              }
                            },
                            [
                              _vm._v(" "),
                              _vm._l(_vm.countryList, function(item, index) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: index,
                                    attrs: { value: item.countryCode }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.countryNameZh) +
                                        "\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                allowClear: "",
                                "show-search": "",
                                "option-filter-prop": "children",
                                placeholder: "所有进度"
                              },
                              on: { change: _vm.handleChange },
                              model: {
                                value: _vm.speedForm.nodeServiceProgressName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.speedForm,
                                    "nodeServiceProgressName",
                                    $$v
                                  )
                                },
                                expression: "speedForm.nodeServiceProgressName"
                              }
                            },
                            [
                              _c("a-select-option", { attrs: { value: "" } }, [
                                _vm._v(
                                  "\n                  全部\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.progressBarList, function(v, i) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: i,
                                    attrs: { value: v.nodeServiceProgressName }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(v.nodeServiceProgressName) +
                                        "\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                "请输入商标名称 / 服务号 / 订单号 关键字",
                              clearable: ""
                            },
                            model: {
                              value: _vm.speedForm.searchContent,
                              callback: function($$v) {
                                _vm.$set(_vm.speedForm, "searchContent", $$v)
                              },
                              expression: "speedForm.searchContent"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", icon: "search" },
                              on: { click: _vm.searchBtn }
                            },
                            [_vm._v(" 搜索 ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { icon: "redo" },
                              on: { click: _vm.handleReset }
                            },
                            [_vm._v(" 重置 ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-box" },
            [
              _c("a-table", {
                attrs: {
                  columns: _vm.columns2,
                  "data-source": _vm.speedList,
                  loading: _vm.tableSpeedLoading,
                  pagination: _vm.pagination,
                  rowKey: function(record, index) {
                    return index
                  },
                  locale: { emptyText: _vm.renderEmpty }
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "serviceProgressStr",
                    fn: function(text, record) {
                      return [
                        record.serviceProgressStr == "待提交资料"
                          ? _c("span", { staticStyle: { color: "#ED7B2F" } }, [
                              _vm._v(_vm._s(record.serviceProgressStr))
                            ])
                          : record.serviceProgressStr == "资料被驳回"
                          ? _c("span", { staticStyle: { color: "#EF3325" } }, [
                              _vm._v(_vm._s(record.serviceProgressStr))
                            ])
                          : _c("span", [
                              _vm._v(_vm._s(record.serviceProgressStr))
                            ])
                      ]
                    }
                  },
                  {
                    key: "operate",
                    fn: function(text, record) {
                      return [
                        _c("div", { staticClass: "operate" }, [
                          _c("div", [
                            _c(
                              "span",
                              {
                                staticClass: "view-progress",
                                on: {
                                  click: function($event) {
                                    return _vm.viewProgress(record)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  查看进度\n                "
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("dl", { staticClass: "quick-access" }, [
          _c("dt", [_vm._v("快捷入口")]),
          _vm._v(" "),
          _c("dd", [
            _c(
              "div",
              {
                staticClass: "quick-access-icon",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/myBrand")
                  }
                }
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/images/common/kj-ic01.png") }
                })
              ]
            ),
            _vm._v("\n        商标注册\n      ")
          ]),
          _vm._v(" "),
          _c("dd", [
            _c(
              "div",
              {
                staticClass: "quick-access-icon",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/myOrder")
                  }
                }
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/images/common/kj-ic02.png") }
                })
              ]
            ),
            _vm._v("\n        我的订单\n      ")
          ]),
          _vm._v(" "),
          _c("dd", [
            _c(
              "div",
              {
                staticClass: "quick-access-icon",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/reviewOpinions")
                  }
                }
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/images/common/kj-ic03.png") }
                })
              ]
            ),
            _vm._v("\n        审查意见\n      ")
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "查看服务进度",
            cancelText: "取消",
            okText: "我知道了",
            width: 608
          },
          on: {
            ok: function() {
              return (_vm.progressModal = false)
            }
          },
          model: {
            value: _vm.progressModal,
            callback: function($$v) {
              _vm.progressModal = $$v
            },
            expression: "progressModal"
          }
        },
        [
          _c("div", { staticClass: "service-progress" }, [
            _c(
              "div",
              { staticClass: "service-box" },
              [
                _c(
                  "a-row",
                  [
                    _c(
                      "a-col",
                      { staticClass: "gutter-row", attrs: { span: 12 } },
                      [
                        _c("div", { staticClass: "gutter-box" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s("服务商品： " + _vm.serviceName) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { staticClass: "gutter-row", attrs: { span: 12 } },
                      [
                        _c("div", { staticClass: "gutter-box" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s("国家： " + _vm.countryNameZh) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { staticClass: "gutter-row", attrs: { span: 12 } },
                      [
                        _c("div", { staticClass: "gutter-box" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s("服务号： " + _vm.serviceNo) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { staticClass: "gutter-row", attrs: { span: 12 } },
                      [
                        _c("div", { staticClass: "gutter-box" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s("订单号： " + _vm.orderNo) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "progress-box" },
              _vm._l(_vm.progressArry, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: {
                      item: true,
                      "item-unprogress":
                        item.trademarkServiceScheduleTimeList.length == 0,
                      "item-bottom":
                        item.trademarkServiceScheduleTimeList.length == 0
                    }
                  },
                  [
                    _c("div", { staticClass: "item-name clearfix" }, [
                      item.trademarkServiceScheduleTimeList.length > 0
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/images/common/progress.svg"),
                              alt: ""
                            }
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/assets/images/common/unprogress.svg"),
                              alt: ""
                            }
                          }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.nodeName))])
                    ]),
                    _vm._v(" "),
                    _vm._l(item.trademarkServiceScheduleTimeList, function(
                      value,
                      k
                    ) {
                      return _c(
                        "div",
                        { key: k, staticClass: "item-time clearfix" },
                        [
                          _c("span"),
                          _vm._v(" "),
                          _c("div", { staticClass: "time" }, [
                            _vm._v(_vm._s(value.time))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text" }, [
                            _vm._v(_vm._s(value.businessName))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              }),
              0
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _c("div", { staticClass: "quick-access-icon" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/common/kj-ic04.png") }
        })
      ]),
      _vm._v("\n        coming soon\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dc0df22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc0df22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/work/components/progress.vue
// module id = null
// module chunks = 